import { render, staticRenderFns } from "./OrderCancel.vue?vue&type=template&id=703e95fe&scoped=true"
import script from "./OrderCancel.vue?vue&type=script&lang=js"
export * from "./OrderCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e95fe",
  null
  
)

export default component.exports